import { t } from 'i18next'

import * as yup from 'yup'

/**
 * Form constants
 */
const EMAIL = 'email'
const FIRST_NAME = 'first_name'
const MID_NAME = 'mid_name'
const LAST_NAME = 'last_name'
const GENDER = 'gender'
const BIRTHDAY = 'birthday'
const PHONE_NUMBER = 'phone_number'
const MOBILE_NUMBER = 'mobile_number'
const ADDRESS = 'address'
const CITY = 'city'
const DISTRICT = 'district'
const STATE = 'state'
const ZIP = 'zip'
const MARITAL_STATE = 'marital_state'
const MARITAL_ZIP = 'marital_zip'
const EMERGENCY_CONTACT_NAME = 'emergency_contact_name'
const EMERGENCY_CONTACT_RELATIONSHIP = 'emergency_contact_relationship'
const EMERGENCY_CONTACT_PHONE = 'emergency_contact_phone'
const EMERGENCY_CONTACT_EMAIL = 'emergency_contact_email'
const EMERGENCY_CONTACT_ADDRESS = 'emergency_contact_address'
const EMERGENCY_CONTACT_CITY = 'emergency_contact_city'
const EMERGENCY_CONTACT_DISTRICT = 'emergency_contact_district'
const EMERGENCY_CONTACT_STATE = 'emergency_contact_state'
const EMERGENCY_CONTACT_ZIP = 'emergency_contact_zip'
const SCHOOL_ACADEMIC_ID = 'school_academic_id'
const TAX_ID = 'tax_id'
const CHILDREN = 'children'
const PICTURE = 'picture'

/**
 * Form model
 */
const formModel = () => {
  return {
    [EMAIL]: {
      label: `${t('common.email')}`,
      name: EMAIL,
      required: true,
    },
    [FIRST_NAME]: {
      label: `${t('common.first-name')}`,
      name: FIRST_NAME,
      required: true,
    },
    [MID_NAME]: {
      label: `${t('common.mid-name')}`,
      name: MID_NAME,
    },
    [LAST_NAME]: {
      label: `${t('common.last-name')}`,
      name: LAST_NAME,
      required: true,
    },
    [GENDER]: {
      label: `${t('common.gender')}`,
      name: GENDER,
      required: true,
    },
    [BIRTHDAY]: {
      label: `${t('common.birthday')}`,
      name: BIRTHDAY,
      required: true,
    },
    [PHONE_NUMBER]: {
      label: `${t('common.phone-number')}`,
      name: PHONE_NUMBER,
    },
    [MOBILE_NUMBER]: {
      label: `${t('common.mobile-number')}`,
      name: MOBILE_NUMBER,
    },
    [ADDRESS]: {
      label: `${t('common.address')}`,
      name: ADDRESS,
    },
    [CITY]: {
      label: `${t('common.city')}`,
      name: CITY,
    },
    [DISTRICT]: {
      label: `${t('common.district')}`,
      name: DISTRICT,
    },
    [STATE]: {
      label: `${t('common.state')}`,
      name: STATE,
    },
    [ZIP]: {
      label: `${t('common.zip')}`,
      name: ZIP,
    },
    [MARITAL_STATE]: {
      label: `${t('common.marital-state')}`,
      name: MARITAL_STATE,
    },
    [MARITAL_ZIP]: {
      label: `${t('common.zip')}`,
      name: MARITAL_ZIP,
    },
    [EMERGENCY_CONTACT_NAME]: {
      label: `${t('common.name')}`,
      name: EMERGENCY_CONTACT_NAME,
    },
    [EMERGENCY_CONTACT_RELATIONSHIP]: {
      label: `${t('common.relationship')}`,
      name: EMERGENCY_CONTACT_RELATIONSHIP,
    },
    [EMERGENCY_CONTACT_PHONE]: {
      label: `${t('common.phone-number')}`,
      name: EMERGENCY_CONTACT_PHONE,
    },
    [EMERGENCY_CONTACT_EMAIL]: {
      label: `${t('common.email')}`,
      name: EMERGENCY_CONTACT_EMAIL,
    },
    [EMERGENCY_CONTACT_ADDRESS]: {
      label: `${t('common.street-address')}`,
      name: EMERGENCY_CONTACT_ADDRESS,
    },
    [EMERGENCY_CONTACT_CITY]: {
      label: `${t('common.city')}`,
      name: EMERGENCY_CONTACT_CITY,
    },
    [EMERGENCY_CONTACT_DISTRICT]: {
      label: `${t('common.district')}`,
      name: EMERGENCY_CONTACT_DISTRICT,
    },
    [EMERGENCY_CONTACT_STATE]: {
      label: `${t('common.state')}`,
      name: EMERGENCY_CONTACT_STATE,
    },
    [EMERGENCY_CONTACT_ZIP]: {
      label: `${t('common.zip')}`,
      name: EMERGENCY_CONTACT_ZIP,
    },
    [SCHOOL_ACADEMIC_ID]: {
      label: `${t('common.school-academic-id')}`,
      name: SCHOOL_ACADEMIC_ID,
    },
    [TAX_ID]: {
      label: `${t('common.tax-id')}`,
      name: TAX_ID,
    },
    [CHILDREN]: {
      label: `${t('common.children')}`,
      name: CHILDREN,
    },
    [PICTURE]: {
      label: `${t('common.picture')}`,
      name: PICTURE,
    },
  }
}

/**
 * Form initial data
 */
export const initialValues = {
  [EMAIL]: '',
  [FIRST_NAME]: '',
  [MID_NAME]: '',
  [LAST_NAME]: '',
  [GENDER]: null,
  [BIRTHDAY]: '',
  [PHONE_NUMBER]: '',
  [MOBILE_NUMBER]: '',
  [ADDRESS]: '',
  [CITY]: '',
  [DISTRICT]: '',
  [STATE]: '',
  [ZIP]: '',
  [MARITAL_STATE]: null,
  [MARITAL_ZIP]: '',
  [EMERGENCY_CONTACT_NAME]: '',
  [EMERGENCY_CONTACT_RELATIONSHIP]: null,
  [EMERGENCY_CONTACT_PHONE]: '',
  [EMERGENCY_CONTACT_EMAIL]: '', 
  [EMERGENCY_CONTACT_ADDRESS]: '',
  [EMERGENCY_CONTACT_CITY]: '',
  [EMERGENCY_CONTACT_DISTRICT]: '',
  [EMERGENCY_CONTACT_STATE]: '',
  [EMERGENCY_CONTACT_ZIP]: '',
  [SCHOOL_ACADEMIC_ID]: '',
  [TAX_ID]: '',
  [CHILDREN]: [],
  [PICTURE]: ''
}

/**
 * Form data validation
 */
export const validationSchema = () =>
  yup.object().shape({
    [EMAIL]: yup
      .string()
      .email(`${t('errors.email-error-message')}`)
      .required(`${t('errors.required-error-message')}`),
    [FIRST_NAME]: yup
      .string()
      .nullable()
      .required(`${t('errors.required-error-message')}`),
    [LAST_NAME]: yup
      .string()
      .nullable()
      .required(`${t('errors.required-error-message')}`),
    [GENDER]: yup
      .object()
      .shape({
        id: yup.string().required(`${t('errors.required-error-message')}`),
        title: yup
          .string()
          .nullable()
          .required(`${t('errors.required-error-message')}`),
      })
      .nullable()
      .required(`${t('errors.required-error-message')}`),
    [CHILDREN]: yup
      .object()
      .shape({
        title: yup
          .string()
          .nullable()
          .required(`${t('errors.required-error-message')}`),
      })
      .nullable(),
    [BIRTHDAY]: yup
      .string()
      .nullable()
      .required(`${t('errors.required-error-message')}`),
  })

export default formModel
